import { Button } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import { ToolBarButtonProps } from '../types';

const ToolBarButton = (props: ToolBarButtonProps) => {
    const { url, label, isExternal } = props;
    const navigate = useNavigate();
    const location = useLocation();

    const handleNavMenu = () => {
        if (url) {
            if (isExternal) {
                window.open(url, '_blank');
                window.focus();
            } else {
                navigate(url);
            }
        }
    };

    const isActiveTab = useMemo(() => {
        if (!url || isExternal) return false;
        return location.pathname === url || location.pathname.startsWith(`${url}/`);
    }, [url, isExternal, location.pathname]);

    return (
        <Button
            variant="text"
            color="inherit"
            onClick={handleNavMenu}
            sx={{
                background: isActiveTab ? '#7eaaca' : '#f8f9fa',
                ':hover': { background: isActiveTab ? '#62a8db' : '#dbdbdb' },
                color: isActiveTab ? '#fff' : 'inherit'
            }}
        >
            {label}
        </Button>
    );
};

export default ToolBarButton;
